import { queryOptions } from '@tanstack/react-query';
import { createCrudApi } from '@core/api/createCrudApi';
import type { BaseEntity } from '@core/interfaces';
import axiosInstance from '@core/utils/axiosInstance';
import type { ChasubleValueFields, StoleValueFields } from './valueFields';

export interface DesignPreset
  extends BaseEntity,
    ChasubleValueFields,
    StoleValueFields {
  name: string;
  sortOrder?: number;
}

/** Omitted values are cleared. */
export interface UpdateDesignPresetData {
  name: string;
  bodyFabric?: number;
  bodyColor?: number;
  panelFabric?: number;
  panelColor?: number;
  patchingType?: string;
  thread?: number;
  trimming?: number;
  gothicType?: string;
  galoon?: number;
  panelDimension?: string;
  liningFabric?: number;
  liningColor?: number;
  stoleSize?: string;
  collar?: number;
  collarFabric?: number;
  collarColor?: number;
  stoleCut?: number;
  cord?: number;
  tassel?: number;
  patchingFabric?: number;
  patchingColor?: number;
}

export interface CreateDesignPresetData extends UpdateDesignPresetData {
  design: number;
}

const designPresetApi = createCrudApi<
  DesignPreset,
  CreateDesignPresetData,
  UpdateDesignPresetData
>('design-preset');

export const createDesignPreset = designPresetApi.create;
export const updateDesignPreset = designPresetApi.update;
export const deleteDesignPreset = designPresetApi.delete;
export const reorderDesignPresets = (designId: number, ids: number[]) =>
  designPresetApi.reorder(ids, { design: designId });

export const designPresetKeys = {
  all: ['designPresets'] as const,
  byDesign: (designId: number) => ['designPresets', designId] as const,
};

export async function getDesignPresets(
  designId: number
): Promise<DesignPreset[]> {
  const { data } = await axiosInstance.get<DesignPreset[]>('/design-preset', {
    params: { design: designId },
  });
  return data;
}

export const designPresetsQuery = (designId: number) =>
  queryOptions({
    queryKey: designPresetKeys.byDesign(designId),
    queryFn: () => getDesignPresets(designId),
  });
